import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent {
  public contact: any;
  public lat = 44.780528;
  public lng =  -0.645748;

  constructor(public formBuilder: FormBuilder) {
    this.getContactForm();
  }

  getContactForm() {
    this.contact = this.formBuilder.group({
      lastname: ['', Validators.required],
      firstname: ['', Validators.required],
      entreprise: ['', Validators.required],
      email: ['', Validators.email],
      message: ['', Validators.required]
    });
  }

}



// WEBPACK FOOTER //
// /Users/Mustafa/Developpement/noxoe/src/components/contact/contact.component.ts